module.exports = __webpack_public_path__ + "static/media/Icon5@2x.d8736b77.png";